<template>
  <v-icon small>{{ supplierTypeIcon(serviceType) }}</v-icon>
</template>

<script>
import { SupplierTypeIconMixin } from "../../../../mixins/SupplierTypeIconMixin";
export default {
  name: "service-type-label",

  props: {
    value: {
      type: String,
      default: () => "ACCOMMODATION",
    },
  },

  mixins: [SupplierTypeIconMixin],

  computed: {
    serviceType() {
      return this.params && this.params.data.serviceType
        ? this.params.data.serviceType
        : this.value;
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/labels/ServiceTypeLabel.vue